import React from "react";
import { InfoPageLayout } from "../Layouts/InfoPageLayout";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AlumniLogo from "../assets/svg/AlumniLogoMainPage.svg"
import { faCalendarCheck, faCheck, faComments, faLanguage, faPhone, faUserGraduate } from "@fortawesome/free-solid-svg-icons";

export function HomePage() {
    const navigate = useNavigate();
    const logIn = function () {
        navigate('/Login')
    }
    return (
    <InfoPageLayout>
        <div className="flex bg-fixed bg-cover bg-center h-screen w-screen items-center justify-center bg-front-page">
                <div className="relative p-4">
                    
                    <div className="flex flex-col justify-center items-center">
                        <img src={AlumniLogo} alt="AlumniLogo" className="h-40 min-w-40" />
                        <h1 className="header lg:text-5xl max-lg:text-6xl max-md:text-5xl z-30"><span className="text-white-700">Alumni Tuition</span></h1>
                        <h2 className="header lg:text-4xl  max-lg:text-xl z-30 text-white-500">Find the best tutors for you</h2>
                        <button onClick={logIn} className="button1  z-30">
                            Get Started
                        </button>
                    </div>
            </div>
        </div>
            <div className="flex flex-col items-center justify-center pt-20">
                <h1 className="header text-4xl text-black"><span className="text-gradient ">Our Prices</span></h1>
                <h2 className="header text-2xl text-gray-600 p-4">See our pricing for one on one tutoring</h2>
            </div>
            <div className="flex w-full p-4 m-auto items-center justify-center flex-col pb-[100px]">
                <div className="rounded-md border border-[#84cc16] md:min-w-[550px] p-8">
                    <div className="header text-2xl text-black">Standard</div>
                    <div className="w-full justify-start">
                        <h1 className="header text-black"><span className="text-lg align-top">$</span><span className="text-6xl">80</span><span className="text-lg align-top">/hr</span></h1>
                    </div>
                    <div className="flex flex-row text-base border border-gray p-4 rounded-lg"><div className="grow p-1">Sign up completely FREE!</div><div> <button className="primary-button mx-auto  text-base" onClick={logIn}>Sign up now!</button></div></div>

                    <hr className="mt-6 mb-6" />
                    <div className="font-semibold text-gray-900 text-sm">
                        <div className="header text-base text-black">Our Services</div>
                        <div className="flex flex-row m-4 gap-4">
                            <div className="grow">One on one tutoring</div>
                            <FontAwesomeIcon icon={faCheck} fontSize="20px" color="green"></FontAwesomeIcon>
                        </div>
                        <div className="flex flex-row m-4  gap-4">
                            <div className="grow">Flexible scheduling</div>
                            <FontAwesomeIcon icon={faCheck} fontSize="20px" color="green"></FontAwesomeIcon>
                        </div>
                        <div className="flex flex-row m-4  gap-4">
                            <div className="grow">Guarranteed refunds if the session doesn't happen</div>
                            <FontAwesomeIcon icon={faCheck} fontSize="20px" color="green"></FontAwesomeIcon>
                        </div>
                        <div className="flex flex-row m-4 gap-4">
                            <div className="flex flex-col grow">
                                <div className="">Cancel sessions at anytime 2 hours before starting</div>
                                <div className="flex flex-row-reverse grow pr-10">- NO ADDITIONAL COSTS!</div>
                            </div>

                            <FontAwesomeIcon icon={faCheck} fontSize="20px" color="green"></FontAwesomeIcon>
                        </div>
                        <div className="flex flex-row m-4  gap-4">
                            <div className="grow">No hidden fees, what you see is what you pay</div>
                            <FontAwesomeIcon icon={faCheck} fontSize="20px" color="green"></FontAwesomeIcon>
                        </div>
                        <div className="flex flex-row m-4  gap-4">
                            <div className="grow">No contracts, cancel anytime</div>
                            <FontAwesomeIcon icon={faCheck} fontSize="20px" color="green"></FontAwesomeIcon>
                        </div>

                    </div>
                </div>
            </div>
            <br />
            <div className="flex flex-col bg-gray-800 text-white ">
                <div className="flex flex-col items-center justify-center pt-20">
                    <h1 className="header text-4xl text-white-400"><span className="text-gradient ">Who are we?</span></h1>
                    <h2 className="header text-2xl text-gray-600 p-4">Why choose us and what do we offer?</h2>
                </div>
                <div className="grid md:grid-cols-2 max-md:grid-cols-1 pt-20 max-w-[900px] mx-auto">
                    <div className="min-w-[400px] text-center"><FontAwesomeIcon icon={faUserGraduate} fontSize="200px" /></div>
                    <div className="flex flex-col grow md:px-10 max-md:px-5 max-md:mt-4">
                        <h1 className="header text-2xl" >Targeted Expertise</h1>
                        <h2 className="text-base ">
                            Alumni tutors are uniquely positioned to understand the exact syllabus, teaching style and assessment methods of the school.
                            This targeted knowledge ensures your child gets ahead with the most relevant academic support, saving time and effort. 
                            
                        </h2>
                    </div>
                </div>
                <div className="grid md:grid-cols-2 max-md:grid-cols-1 pt-20 max-w-[900px] mx-auto">

                    <div className="flex flex-col grow md:px-10 max-md:px-5 max-md:order-last">
                        <h1 className="header text-2xl">Personalised Support</h1>
                        <h2 className="text-base">
                            Because the tutors share a common educational background with your child, they can tailor their approach to suit the
                            specific challenges and opportunities presented by the school curriculum.
                        </h2>
                    </div>
                    <div className="min-w-[400px] text-center"><FontAwesomeIcon icon={faLanguage}  fontSize="200px"/></div>
                </div>
                <div className="grid md:grid-cols-2 max-md:grid-cols-1 pt-20 max-w-[900px] mx-auto">
                    <div className="min-w-[400px] text-center"><FontAwesomeIcon icon={faCalendarCheck} fontSize="200px" /></div>
                    <div className="flex flex-col grow md:px-10 max-md:px-5 max-md:mt-4">
                        <h1 className="header text-2xl">Convenience</h1>
                        <h2 className="text-base">
                            All tutoring sessions are totally flexible around you and your child's schedule. Whether online or in person,
                            our advanced online system allows you to choose the times that work for you. Moreover, our automated billing makes it so you will never need to worry bank transfers or cash payments to our private tutors.
                        </h2>
                    </div>
                </div>
                <div className="grid md:grid-cols-2 max-md:grid-cols-1 pt-20 max-w-[900px] mx-auto">
                    <div className="flex flex-col grow md:px-10 max-md:px-5 max-md:order-last max-md:mt-4">
                        <h1 className="header text-2xl" >Scheduling and Communication</h1>
                        <h2 className="text-base">
                            Our user-friendly website includes a seamless booking calendar and a secure messaging portal for direct communication with tutors.
                            Our responsive team is also always on hand to resolve scheduling issues or answer any questions. Managing your child's tutoring sessions has never been easier!
                        </h2>
                    </div>
                    <div className="min-w-[400px] text-center"><FontAwesomeIcon icon={faComments} fontSize="200px" /></div>
                </div>
                <div className="grid md:grid-cols-2 max-md:grid-cols-1 pt-20 max-w-[900px] mx-auto pb-20">
                    <div className="min-w-[400px] text-center"><FontAwesomeIcon icon={faPhone} fontSize="200px" /></div>
                    <div className="flex flex-col grow md:px-10 max-md:px-5 max-md:order-last max-md:mt-4">
                        <h1 className="header text-2xl" >Secure Payment Automation and 24/7 Support</h1>
                        <h2 className="text-base">
                            Each session is automated with payments using <i>Stripe</i> to manage all your secure payment needs.
                            Something gone wrong? Send us an email. We are here, we will get to you as soon as possible!
                        </h2>
                    </div>
                  
                </div>

            </div>
            {/* <div className="flex flex-col max-w-[925px] mx-auto items-center pt-10 pb-20">
                <div className="flex flex-col items-start justify-start w-full p-4">
                    <h1 className="text-slate-700 font-semibold text-xl"><span>From our past students</span></h1>
                </div>
                <div className="grid w-full gap-4 p-4 max-md:grid-cols-2  md:grid-cols-4 items-center justify-center">
                    <div className="section-box p-4 min-h-[200px] flex flex-col">
                        <div className="flex flex-col grow">
                            <div className="text-base text-black">"I was able to find a tutor that helped me understand my subjects better"</div>
                           
                        </div>
                        <div>
                            <h2 className="text-lg text-slate-700" >- John Doe</h2>
                        </div>
                    </div>
                    <div className="section-box p-4 min-h-[200px] flex flex-col">
                        <div className="flex flex-col grow">
                            <div className="text-base text-black">"I was able to find a tutor that helped me understand my subjects better"</div>

                        </div>
                        <div>
                            <h2 className="text-lg text-slate-700" >- John Doe</h2>
                        </div>
                    </div>
                    <div className="section-box p-4 min-h-[200px] flex flex-col">
                        <div className="flex flex-col grow">
                            <div className="text-base text-black">"I was able to find a tutor that helped me understand my subjects better"</div>

                        </div>
                        <div>
                            <h2 className="text-lg text-slate-700" >- John Doe</h2>
                        </div>
                    </div>
                    <div className="section-box p-4 min-h-[200px] flex flex-col">
                        <div className="flex flex-col grow">
                            <div className="text-base text-black">"I was able to find a tutor that helped me understand my subjects better"</div>

                        </div>
                        <div>
                            <h2 className="text-lg text-slate-700" >- John Doe</h2>
                        </div>
                    </div>
                </div>
            </div> */}
            {/*<hr></hr>*/}
            {/*<div className="flex flex-col max-w-[925px] mx-auto items-center pt-10 pb-20">*/}
            {/*    <div className="flex flex-col items-start justify-start w-full">*/}
            {/*        <h1 className="text-lg text-slate-700 font-semibold"><span className="text-gradient ">Our partnered Schools</span></h1>*/}
            {/*    </div>*/}

            {/*</div>*/}
    </InfoPageLayout>);
}